import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import "./OrderPlaced.css";
import CommonBreadcrumb from "./../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import Login_Succes_Lottie from "./../animation/login_succes_lottie/Login_Succes_Lottie";
import { getOrder } from "../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";

const OrderSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [showCongratsModal, setShowCongratsModal] = useState(false);
  const [redirectTimer, setRedirectTimer] = useState(null);

  const productsdetails = useSelector(
    (state) => state.product.productdetails?.get_order,
  );

  useEffect(() => {
    dispatch(getOrder());
  }, [dispatch]);

  useEffect(() => {
    if (productsdetails) {
      const orderType = sessionStorage.getItem("orderType");

      if (orderType === "shareholder") {
        setShowCongratsModal(true);
        sessionStorage.removeItem("orderType");
      }
    }
  }, [productsdetails]);

  useEffect(() => {
    if (!showCongratsModal) {
      const timer = setTimeout(() => {
        navigate("/home");
      }, 5000);
      setRedirectTimer(timer);
    }

    return () => {
      if (redirectTimer) clearTimeout(redirectTimer);
    };
  }, [navigate, showCongratsModal]);

  const handleCloseModal = () => {
    setShowCongratsModal(false);
    navigate("/home");
  };

  const breadcrumbItems = [
    { label: "Product", link: "/products" },
    { label: "Cart", link: "/cart" },
    { label: "Order Placed" },
  ];

  /* ---------------- TRACK SHIPMENT LOGIC ---------------- */

  const orderStatusId = productsdetails?.order_status_id;

  const steps = [
    {
      id: 1,
      title: "Order Confirmed",
      desc: "We have received your order and it is being prepared.",
      time: new Date(productsdetails?.created_at).toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    },
    {
      id: 2,
      title: "Order Processing",
      desc: "Your order has been shipped and is on the way.",
    },
    {
      id: 3,
      title: "Delivered",
      desc: "Your order has been delivered successfully.",
    },
  ].map((step) => {
    let status = "pending";

    if (step.id < orderStatusId) {
      status = "done";
    } else if (step.id === orderStatusId) {
      status = "active";
    }

    return {
      ...step,
      status,
    };
  });

  /* ------------------------------------------------------ */

  return (
    <section className="order-plased-section">
      <CommonBreadcrumb items={breadcrumbItems} />

      <Container className="py-5 ">
        {/* HEADER */}
        <div className="d-flex justify-content-center">
          <div className="mb-4 order-confirm ">
            <Login_Succes_Lottie />
            <div>
              <h4>Order Confirmed!</h4>
              <p>
                Your order has been successfully placed & confirmed. We have
                received your order & it is being prepared for processing.
              </p>
            </div>
          </div>
        </div>

        <Row className="g-4 card-row justify-content-center align-items-stretch ">
          {/* LEFT CARD */}
          <Col lg={5}>
            <Card className="card-one p-3 shadow-sm border-0 rounded-4 h-100">
              <div className="d-flex justify-content-between small text-muted">
                <div className="order">
                  <span> Order Number </span>
                  <strong># {productsdetails?.order_number}</strong>
                </div>

                <div className="order order-date">
                  <span> Order Date </span>
                  <strong>
                    {new Date(productsdetails?.created_at).toLocaleDateString(
                      "en-US",
                      {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      },
                    )}
                  </strong>
                </div>
              </div>

              <div className="product-box">
                <div className="d-flex product-card align-items-start">
                  <img src="/images/cart/productImg.png" alt="product" />

                  <div className="product-details">
                    <h6>
                      {productsdetails?.order_details?.[0]?.product?.name}
                    </h6>

                    <p className="border-bottom">
                      {htmlToReactParser.parse(
                        productsdetails?.order_details?.[0]?.product
                          ?.description,
                      )}
                    </p>

                    <span>
                      {productsdetails?.order_details?.[0]?.product?.power} -{" "}
                      {productsdetails?.order_details?.[0]?.quantity}{" "}
                      {productsdetails?.order_details?.[0]?.quantity > 1
                        ? "Bottles"
                        : "Bottle"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="price-section">
                <div className="price-row">
                  <span>Subtotal</span>
                  <span className="price-rs">
                    ₹. {productsdetails?.sub_total}/-
                  </span>
                </div>

                <div className="price-row">
                  <span>Standard Shipping</span>
                  <span className="price-rs">
                    ₹. {productsdetails?.shipping_charges}/-
                  </span>
                </div>

                <div className="price-row">
                  <span>Grand Total</span>
                  <span className="price-rs">
                    ₹. {productsdetails?.grand_total}/-
                  </span>
                </div>
              </div>

              <div className="text-center small mt-3">
                <p className="trust-text ">
                  <img src="/images/cart/100-percent.png" alt="not" /> Natural &
                  Trusted Product
                </p>

                <p className="sub-trust-text">
                  Made with natural ingredients & trusted for quality and
                  purity.
                </p>
              </div>
            </Card>
          </Col>

          {/* RIGHT TRACKER */}
          <Col lg={5}>
            <Card className="card-two p-4 shadow-sm border-0 rounded-4 h-100">
              <div className="d-flex top-heading justify-content-between align-items-center mb-3">
                <h6 className="mb-0">
                  <FontAwesomeIcon
                    className="location-icon"
                    icon={faLocationDot}
                  />
                  Track Shipment
                </h6>

                <span className="order-box">
                  <div className="dot"></div>{" "}
                  {productsdetails?.order_status?.name}
                </span>
              </div>

              <div className="timeline">
                {steps.map((step, i) => (
                  <div key={i} className={`timeline-step ${step.status}`}>
                    <div className="timeline-dot">
                      <div className="inner_dot"></div>
                    </div>

                    <div className="timeline-content">
                      <div className="d-flex justify-content-between">
                        <strong className="order-text">{step.title}</strong>

                        {step.time && (
                          <small className="text-muted date-time">
                            {step.time}
                          </small>
                        )}
                      </div>

                      <div className="text-muted small order-desc">
                        {step.desc}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          </Col>
        </Row>

        {/* BUTTON */}
        <div className="text-center mt-5">
          <WhiteButton
            className="w-btn"
            title={"Back to Home"}
            bg="#000"
            color="#f35f37"
            hoverColor="#f35f37"
            hoverBg={"#000"}
            onClick={() => navigate("/home")}
          />
        </div>
        <Modal
          show={showCongratsModal}
          onHide={handleCloseModal}
          centered
          backdrop="static"
          keyboard={false}
          size="md"
        >
          <Modal.Body className="text-center p-5">
            <div className="mb-4 succes-lottie-center-wrapper">
              <Login_Succes_Lottie />
            </div>

            <h3 className="text-success mb-3">Congratulations!</h3>
            <h4>You are now a Channel Partner!</h4>
            <p className="text-muted mt-3">
              Welcome to our partner network. Congratulations on becoming a
              Channel Partner
            </p>

            <WhiteButton
              title="Continue to Home"
              bg="#F35F37"
              color="#fff"
              hoverBg="#e04e2a"
              onClick={handleCloseModal}
              className="mt-4 px-5"
            />
          </Modal.Body>
        </Modal>
      </Container>
    </section>
  );
};

export default OrderSuccess;
